import React, { forwardRef } from 'react';
import cm from 'classnames';
import styles from './_select.module.scss';

export interface Option {
  label: string;
  value: number;
  disabled?: boolean;
}

interface Props extends React.SelectHTMLAttributes<HTMLSelectElement> {
  className?: string;
  options?: Option[];
  disabledOptions?: boolean;
  colored?: true;
}

const Select = forwardRef<HTMLSelectElement, Props>(
  ({ className, options, placeholder, disabledOptions, colored, ...rest }, ref) => {
    return (
      <div className={cm(styles.Select, className, { [styles['Select--primary']]: colored })}>
        <select ref={ref} {...rest}>
          {placeholder && (
            <option value="" disabled hidden>
              {placeholder}
            </option>
          )}
          {options &&
            options.map((el) => (
              <option key={el.value} value={el.value} disabled={el.disabled && disabledOptions}>
                {el.label}
              </option>
            ))}
        </select>
      </div>
    );
  }
);

Select.displayName = 'Select';

export { Select };
